<template>
  <div class="invoice__container">
    <icon-view class="ml-2" icon="fa fa-flag" title="Discusión de Plan" />
    <div class="row mx-0 ml-md-4">
      <div class="col-12 col-md-3 mt-3">
        <label for="bill-discussion">
          ¿Estará facturando la discusión del plan?
        </label>
        <custom-radio
          v-model="model.isPlanBilling"
          is-disabled
          is-inline
          name="bill-discussion"
          customErrorMsg=""
          :options="defaultOptions"
        />
      </div>

      <div class="col-12 mt-3 col-md-3">
        <custom-drop-down
          id="serviceSpecialist"
          v-model="model.specialist"
          disabled
          fieldkey="id"
          fieldname="name"
          label="Especialista que discutió el plan: "
          name="serviceSpecilist"
          :options="specialists"
        />
      </div>

      <div class="col-12 mt-3 col-md-2">
        <custom-date-picker
          v-model="model.date"
          class-container=""
          disabled
          label="Fecha:"
          placeholder="DD/MM/YYYY"
        />
      </div>

      <div class="col-12 mt-3 col-md-2">
        <custom-time-picker
          v-model="model.startTime"
          class-container=""
          disabled
          end-time-value="19:55"
          label="Hora Desde:"
          placeholder="HH:mm"
        />
      </div>

      <div class="col-12 mt-3 col-md-2">
        <custom-time-picker
          v-model="model.endTime"
          disabled
          end-time-value="20:00"
          label="Hora Hasta:"
          placeholder="HH:mm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomDatePicker from 'custom-date-picker';
import CustomRadio from 'custom-radio';
import CustomTimePicker from 'custom-time-picker';
import IconView from 'icon-view';
import CustomDropDown from 'custom-drop-down';

export default {
  name: 'PlanDiscussion',
  components: {
    CustomDatePicker,
    CustomRadio,
    CustomTimePicker,
    IconView,
    CustomDropDown,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        date: null,
        endTime: null,
        startTime: null,
        isPlanBilling: null,
        argumentativeSpecialistId: null,
        argumentativeSpecialistName: null,
      }),
    },
  },
  data() {
    return {
      model: {
        date: null,
        isPlanBilling: null,
        endTime: null,
        startTime: null,
        specialist: {
          id: null,
          name: null,
        },
      },
      defaultOptions: [
        {
          id: 1,
          name: 'bill-discussion-rbnt',
          value: true,
          label: 'Si',
          check: false,
        },
        {
          id: 2,
          name: 'bill-discussion-rbnt',
          value: false,
          label: 'No',
          check: false,
        },
      ],
    };
  },
  computed: {
    specialists() {
      return [ this.model.specialist ];
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.model.specialist.id = newValue.argumentativeSpecialistId;
        this.model.specialist.name = newValue.argumentativeSpecialistName;
        this.model.isPlanBilling = newValue.isPlanBilling ? 1 : 2;
        Object.assign(this.model, newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables/_colors.scss';

.invoice__container {
  padding: 1rem 0.5rem;
  border-radius: 0.35rem;
  background: map-get($colors, 'secondary-3');
  border-left: 0.25rem solid map-get($colors, 'primary-1') !important;

  ::v-deep {
    .title-icon {
      color: map-get($colors, 'primary-1') !important;
    }
    .dot {
      background: map-get($colors, 'white') !important;
    }
  }
}
</style>
